import React from 'react';
import { Button, TextStyle } from '@superops/ui-design-system';

function CVSSScoreCell(props) {
  const { cell } = props;

  // Extract CVSS score from cell data
  const cvssScore = cell?.row?.original?.maxCVSSScore || cell?.value || 0;

  // Format score to one decimal place
  const formattedScore = parseFloat(cvssScore).toFixed(1);
  function handlePatchSummaryModal() {
    if (cvssScore) {
      const cellInfo = cell?.row?.original?.patchDetail
        ? cell?.row?.original?.patchDetail
        : cell?.row?.original;
      cell?.column?.actions?.handleCVSSScoreModal({
        patchId: cellInfo?.patchId,
        kbNumber: cellInfo?.kbNumbers?.[0]?.kbNumber
      });
    }
  }

  return cvssScore ? (
    <Button plain disabled={false} onClick={handlePatchSummaryModal}>
      <span>{formattedScore}</span>
    </Button>
  ) : (
    <TextStyle disabled>
      <span>NA</span>
    </TextStyle>
  );
}

export default CVSSScoreCell;
